export default __webpack_public_path__ + "assets/Newspace.a5cd9839.png";